/* eslint-disable react/no-unescaped-entities */

import React from 'react'
import { useTranslation } from 'lib/i18n'

import Link from 'components/Link/Link'
import styles from 'components/ProductPage/shared/VideoRequestForm.module.css'
import Typography from 'components/UI/Typography/Typography'

export default function BusinessTerms() {
  const { t } = useTranslation()

  return (
    <div className={styles.businessTerms}>
      <Typography.H6>
        {t(
          'VideoRequestForm.businessTerms.businessTerms.ourTerms',
          'Terms of use',
        )}
      </Typography.H6>
      <ul>
        <li>
          {t(
            'VideoRequestForm.businessTerms.term1',
            'Can be used for 90 days from the date of delivery',
          )}
        </li>
        <li>
          {t(
            'VideoRequestForm.businessTerms.term3',
            'Can be uploaded to your web page and/or social media channels, other channels prohibited',
          )}
        </li>
        <li>
          {t(
            'VideoRequestForm.businessTerms.term4',
            'Cannot be used in conjunction with offensive material/texts or such',
          )}
        </li>
      </ul>
      <div className={styles.fullTerms}>
        {t('VideoRequestForm.termsText', 'By continuing you agree to ')}{' '}
        <Link href="/terms-for-business-requests">
          <a target="_blank">
            {t(
              'VideoRequestForm.termsLinkBusinessRequestFull',
              'our full business request terms',
            )}
          </a>
        </Link>
      </div>
    </div>
  )
}
